<template lang="pug">
  .d-flex.align-items-center.justify-content-center(style="min-height: 100vh;")
    .un-support
      a.un-support__btn(href="/")
        i.far.fa-arrow-left.un-support__icon
      h1.text-center
        img(
          src="/static/img/app/logo-goqme.svg",
          alt="GoQme"
        )
      dl.text-center.un-support__dl
        dt.un-support__term
          | 対応ブラウザではありません！
        dd.un-support__desc
          | ご利用のブラウザはサポートされていません。
          br
          | 以下いずれかのブラウザにて
          br
          | GoQmeをご利用ください。
      ul.list-unstyled.d-flex.justify-content-center.un-support__browsers
        li.un-support__browser-item(v-if="!isIOS")
          img.un-support__browser-img(
            src="/static/img/app/icon-browser_chrome.svg",
            alt="Google Chrome"
          )
          br
          | Chrome
          br
          | Ver.58〜
        li.un-support__browser-item(v-if="!isIOS && !isAndroidOS")
          img.un-support__browser-img(
            src="/static/img/app/icon-browser_firefox.svg",
            alt="Firefox"
          )
          br
          | FireFox
          br
          | Ver.56〜
        li.un-support__browser-item(v-if="!isAndroidOS && !isWindows")
          img.un-support__browser-img(
            src="/static/img/app/icon-browser_safari.svg",
            alt="Safari"
          )
          br
          | Safari
          br
          | 12.1.4〜
        li.un-support__browser-item(v-if="!isIOS && !isAndroidOS")
          img.un-support__browser-img(
            src="/static/img/app/icon-browser_edge.svg",
            alt="Microsoft Edge"
          )
          br
          | Microsoft Edge
          br
          | Ver.80〜
</template>

<script>
import { getOs } from '../../utils/checkAppSupport'

export default {
  name: 'UnSupport',
  data () {
    return {
      isIOS: false,
      isAndroidOS: false,
      isWindows: false
    }
  },
  created () {
    const uaOs = getOs()

    // Windowsかどうかチェック
    this.isWindows = uaOs === 'Windows'

    // iOSかどうかチェック
    this.isIOS = uaOs === 'iOS'

    // AndroidOSかどうかチェック
    this.isAndroidOS = uaOs === 'Android'
  }
}
</script>
